export default "__VITE_ASSET__P$v2fNCN__"